import React from 'react';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);

const AppModalRow = (props) => {

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    };

    localize();

    function iosIcon() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return require("assets/img/icons/apps/appstore-badge-es.svg").default;
            case "ru":
                return require("assets/img/icons/apps/appstore-badge-ru.svg").default;
            default:
                return require("assets/img/icons/apps/app_en.svg").default;
        }
    }

    function androidIcon() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return require("assets/img/icons/apps/google-play-badge-es.png");
            case "ru":
                return require("assets/img/icons/apps/google-play-badge-ru.png");
            default:
                return require("assets/img/icons/apps/google-play-badge-en.png");
        }
    }

    function openAndroidApp() {
        window.open(`https://play.google.com/store/apps/details?id=com.openmanagerapp.open`, "_blank")
    }

    function openIOSApp() {
        window.open(`https://apps.apple.com/es/app/open-manager/id1462618811?l=${localeHelpers.currentLocale()}`, "_blank")
    }

    function dontShowAgain() {
        props.dontShowAppModalRow()
    }

    return (
        <div className="bg-success">
            <div className="bg-success text-center align-items-center">
                <div className="modal-header m-0 p-1">
                    {/*<h4 className="text-white text-center align-items-center justify-content-center" style={{width: "100%"}}> {commonStrings.navigation.download_open_app} </h4>*/}
                    <button
                        style={{zIndex: 100}}
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => dontShowAgain()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>


            </div>
            <Row className="justify-content-center mr-0">
                <Col className="row align-items-center justify-content-center ml-2">
                    <img
                        alt="yo"
                        height={40}
                        onClick={() => openIOSApp()}
                        src={iosIcon()}
                    />
                </Col>
                <Col className="row align-items-center justify-content-center mr-0" style={{marginRight: 0}}>
                    <img
                        alt="..."
                        height={60}
                        onClick={() => openAndroidApp()}
                        src={androidIcon()}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default AppModalRow;